import Header from '../../components/Header';
import ManagerSidebar from '../../components/manager/ManagerSidebar';
import SettingsTab from '../../components/manager/SettingsTab';

const SettingsScreen = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <ManagerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Settings'} orderSubtitle={'Manage system defaults'} showButton={false} /> 
          <section className='mt-10 flex gap-5'>
                 <SettingsTab /> 
          </section>
        </main>
      </section>

    </>
  )
}
export default SettingsScreen